// Org-level feature flag (GET /feature-config) gating the whole DOF-662
// policy-consent feature: consent enforcement, consent screens, and the
// read-only policy entries. Fail-closed — flag missing/off = feature dark.
export const POLICY_CONSENT_FEATURE_KEY = 'POLICY_CONSENT'
